import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUpload } from "@fortawesome/pro-regular-svg-icons";
import {
	Card,
	Table,
	Button,
	notification,
	Row,
	Col,
	Flex,
	Popconfirm,
} from "antd";
import dayjs from "dayjs";
import {
	checkNetworkStatus,
	readFile,
	setFileStorage,
} from "../../../providers/useCapacitorStorage";
import { POST } from "../../../providers/useAxiosQuery";
import notificationErrors from "../../../providers/notificationErrors";
import { userData } from "../../../providers/companyInfo";

export default function PageSurveyPending() {
	const [dataSource, setDataSource] = useState([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	// console.log("dataSource::: ", dataSource);

	useEffect(() => {
		readFile(
			`fsuu_dsac_survey_diosys/survey_pending_list_${userData().id}.txt`,
		).then(async (res) => {
			if (res && res.data) {
				const parsed = JSON.parse(res.data);

				const dataWithKeys = parsed.map((item, index) => ({
					...item,
					rowKey: `${item.id}-${index}`,
				}));

				setDataSource(dataWithKeys);
			}
		});

		return () => {};
	}, []);

	const { mutate: mutateSurveyBulk, isLoading: isLoadingSurveyBulk } = POST(
		`api/form_question_answer_batch_bulk`,
		"form_question_answer_bulk_store",
	);

	const handleUploadBulk = () => {
		let data = [];

		selectedRowKeys.forEach((item) => {
			let findData = dataSource.find((f) => f.rowKey === item);

			if (findData) {
				let questionAnswerList = [];

				findData.form_question_categories.forEach((item2) => {
					let questionAnswers = [];
					item2.form_questions.forEach((item3) => {
						let sub_answer = null;

						if (item3.sub_answer) {
							sub_answer = Array.isArray(item3.sub_answer)
								? JSON.stringify(item3.sub_answer)
								: item3.sub_answer;
						}

						questionAnswers.push({
							user_id: userData().id,
							form_id: findData.id,
							date_start_answer: findData.date_start_answer,
							date_end_answer: findData.date_end_answer,
							form_question_category_id: item2.id,
							form_question_id: item3.id,
							answer: Array.isArray(item3.answer)
								? JSON.stringify(item3.answer)
								: item3.answer,
							sub_answer: sub_answer,
							created_by: userData().id,
							created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
							updated_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
						});
					});

					questionAnswerList.push(...questionAnswers);
				});

				data.push({
					latitude: findData.latitude ?? "",
					longitude: findData.longitude ?? "",
					accuracy: findData.accuracy ?? "",
					altitude: findData.altitude ?? "",
					heading: findData.heading ?? "",
					altitude_accuracy: findData.altitudeAccuracy ?? "",
					speed: findData.speed ?? "",
					user_id: userData().id,
					form_id: findData.id,
					created_by: userData().id,
					form_question_answers: questionAnswerList,
				});
			}
		});

		checkNetworkStatus().then((res) => {
			if (res.connected) {
				mutateSurveyBulk(
					{ data: data },
					{
						onSuccess: (res2) => {
							if (res2.success) {
								notification.success({
									message: "Survey",
									description: res2.message,
								});

								let dataSourceTemp = dataSource.filter(
									(x) => !selectedRowKeys.includes(x.rowKey),
								);

								setFileStorage(
									"fsuu_dsac_survey_diosys",
									`survey_pending_list_${userData().id}`,
									dataSourceTemp,
								).then(() => {
									setDataSource(dataSourceTemp);
									setSelectedRowKeys([]);
								});
							} else {
								notification.error({
									message: "Survey Pending",
									description: res2.message,
								});
							}
						},
						onError: (err) => {
							notificationErrors(err);
						},
					},
				);
			} else {
				notification.error({
					message: "Survey Pending",
					description:
						"I'm sorry, but you are currently not connected to the internet. Please reconnect to the internet and attempt your request again.",
				});
			}
		});
	};

	const columns = [
		{
			title: "Action",
			key: "action",
			render: (_, record) => {
				return (
					<Flex gap={10}>
						<Popconfirm
							title="Are you sure you want to delete this data	?"
							onConfirm={() => {
								let dataSourceTemp = dataSource.filter(
									(f) => f.rowKey !== record.rowKey,
								);

								setDataSource(dataSourceTemp);

								setSelectedRowKeys((prev) =>
									prev.filter((key) => key !== record.rowKey),
								);

								setFileStorage(
									"fsuu_dsac_survey_diosys",
									`survey_pending_list_${userData().id}`,
									dataSourceTemp,
								).then(() => {
									notification.success({
										message: "Survey",
										description: "Data has been successfully deleted.",
									});
								});
							}}
							okText="Yes"
							cancelText="No"
						>
							<Button
								type="link"
								className="btn-delete p-0 w-auto h-auto"
								icon={<FontAwesomeIcon icon={faTrash} />}
							/>
						</Popconfirm>
					</Flex>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "survey_status",
			key: "survey_status",
		},
		{
			title: "Form Name",
			dataIndex: "form_name",
			key: "form_name",
		},
		{
			title: "Date Start Answer",
			dataIndex: "date_start_answer",
			key: "date_start_answer",
			render: (text) => dayjs(text).format("YYYY-MM-DD h:mm A"),
		},
		{
			title: "Date End Answer",
			dataIndex: "date_end_answer",
			key: "date_end_answer",
			render: (text) => dayjs(text).format("YYYY-MM-DD h:mm A"),
		},
	];
	return (
		<Row gutter={[12, 12]}>
			{selectedRowKeys.length > 0 ? (
				<Col
					xs={24}
					sm={24}
					md={24}
					lg={24}
					xl={24}
					style={{ marginLeft: "20px" }}
				>
					<Button
						icon={<FontAwesomeIcon icon={faUpload} />}
						className="btn-main-primary br-20"
						loading={isLoadingSurveyBulk}
						onClick={handleUploadBulk}
					>
						Upload
					</Button>
				</Col>
			) : null}

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Card>
					<Table
						dataSource={dataSource}
						columns={columns}
						rowKey="rowKey"
						scroll={{ x: "max-content" }}
						rowSelection={{
							selectedRowKeys,
							onChange: (keys, rows) => {
								const invalidRows = rows.filter(
									(item) => item.survey_status !== "Ready to Upload",
								);

								if (invalidRows.length > 0) {
									notification.error({
										message: "Error",
										description: "Please finish answer the survey.",
									});

									const validKeys = rows
										.filter((item) => item.survey_status === "Ready to Upload")
										.map((item) => item.rowKey);

									setSelectedRowKeys(validKeys);
								} else {
									setSelectedRowKeys(keys);
								}
							},
						}}
					/>
				</Card>
			</Col>
		</Row>
	);
}
